import React, { forwardRef, useCallback, useState } from 'react'
import { Medium, Semibold } from 'streamr-ui/css/consts'
import styled from 'styled-components'
import { Timeframe } from '~utils/consts'

const timeframes = [Timeframe.Day, Timeframe.Week, Timeframe.Month, Timeframe.Year, Timeframe.All]

const Links = styled.ul`
    box-sizing: border-box;
    display: grid;
    grid-template-columns: repeat(${timeframes.length}, 1fr);
    gap: 0.5rem;
    height: 100%;
    list-style: none;
    margin: 0;
    padding: 0;
    width: 100%;

    li {
        height: 100%;
    }
`

const TabButton = styled.button`
    appearance: none;
    background-color: ${({ active }) => (active ? '#FFFFFF' : 'transparent')};
    border-radius: 4px;
    border: 0;
    color: ${({ active }) => (active ? '#525252' : '#A3A3A3')};
    cursor: pointer;
    display: block;
    font-size: 0.875rem;
    font-weight: ${Semibold};
    height: 100%;
    letter-spacing: 2px;
    line-height: normal;
    outline: none !important;
    padding: 0 0.75rem;
    text-align: center;
    text-transform: uppercase;
    transition: color 180ms ease-in-out, opacity 180ms ease-in-out;
    width: 100%;

    :hover {
        color: ${({ active }) => (active ? '#525252' : 'white')};
    }

    :disabled,
    :disabled:hover,
    &[disabled],
    &[disabled]:hover {
        color: ${({ active }) => (active ? '#525252' : '#A3A3A3')};
        opacity: 0.5;
        cursor: auto;
    }
`

const UnstyledNav = forwardRef(function UnstyledNav(
    { className, switchTimeframe, style, loading },
    ref,
) {
    const [activeNav, setActiveNav] = useState(Timeframe.Day)

    const updatePriceChart = useCallback(
        (timePeriod) => {
            switchTimeframe(timePeriod)
            setActiveNav(timePeriod)
        },
        [switchTimeframe],
    )

    return (
        <div className={className} ref={ref} style={style}>
            <Links>
                {timeframes.map((timeframe) => (
                    <li key={timeframe}>
                        <TabButton
                            active={activeNav === timeframe}
                            onClick={() => updatePriceChart(timeframe)}
                            type="button"
                            disabled={!!loading}
                        >
                            {timeframe}
                        </TabButton>
                    </li>
                ))}
            </Links>
        </div>
    )
})

const Nav = styled(UnstyledNav)`
    font-size: 0.75rem;
    font-weight: ${Medium};
    line-height: 1rem;
    background: #323232;
    padding: 4px;
    border-radius: 8px;
    height: 48px;
    width: 100%;
    box-sizing: border-box;
`

export default Nav
